import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useAccountStore = defineStore('accounts', {
  state: () => ({
    accounts: [],
    loading: false,
    error: null,
  }),
  actions: {
    async fetchAccounts() {
      this.loading = true;
      try {
        const response = await authFetch(`${API_URL}/accounts`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.accounts = await response.json();
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async addAccount(account) {
      try {
        const transformedAccount = {
          ...account,
          date: account.date ? new Date(account.date).toISOString().split('T')[0] : null
        };

        const response = await authFetch(`${API_URL}/accounts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(transformedAccount),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const newAccount = await response.json();
        this.accounts.push(newAccount);
      } catch (error) {
        this.error = error;
        throw error;
      }
    },
    async deleteAccount(accountId) {
      try {
        const response = await authFetch(`${API_URL}/accounts/${accountId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        this.accounts = this.accounts.filter(account => account.id !== accountId);
      } catch (error) {
        console.error('Error deleting account:', error);
        this.error = error;
        throw error;
      }
    },
    
    async updateAccount(accountId, account) {
      try {
        const transformedAccount = {
          ...account,
          date: account.date ? new Date(account.date).toISOString().split('T')[0] : null
        };
    
        const response = await authFetch(`${API_URL}/accounts/${accountId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(transformedAccount)
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const updatedAccount = await response.json();
        const index = this.accounts.findIndex(a => a.id === accountId);
        if (index !== -1) {
          this.accounts[index] = updatedAccount;
        }
      } catch (error) {
        console.error('Error updating account:', error);
        this.error = error;
        throw error;
      }
    }
  },
});
